import Vue from 'vue'
import Router from 'vue-router'


import FormView from '@/FormView'
//import ZetosThankYouView from '@/ZetosThankYouView'
import NauThankYouView from '@/NauThankYouView'
import ZetosCalcView from '@/ZetosCalcView'
import ZetosResignView from '@/ZetosResignView'
import ZetosRejectView from '@/ZetosRejectView'
import ZetosClientView from '@/ZetosClientView'

import RedirectView from '@/RedirectView';
//import NauProposalView from '@/NauProposalView'
import NauProposalView from '@/NauProposalView'

import ZetosTimeoutPage from '@/ZetosTimeoutPage'
import ZetosPDFView from '@/ZetosPDFView'
import AuthologicReturn from "@/AuthologicReturn";
import EasyCheckOkView from '@/EasyCheckOkView';

import { bus } from '@/main';


Vue.use(Router);

export const router = new Router({
  routes: [

   {
      path: '/',
      alias: ['/quickform', '/verifycode', '/fullform', '/kontox'],
      name: 'ZetosFormView',
      component: FormView

    },
    {
      path: '/authologic',
      name: 'AuthologicReturn',
      component: AuthologicReturn
    },
    {
      path: '/thankyou',
      name: 'NauThankYouView',
      component: NauThankYouView
    },

    {
      path: '/pdf',
      name: 'ZetosPDFView',
      component: ZetosPDFView
    },


    {
      path: '/client',
      name: 'ZetosClientView',
      component: ZetosClientView
    },

    {
      path: '/proposal',
      name: 'NauProposalView',
      component: NauProposalView
    },

    {
      path: '/resign',
      name: 'ZetosResignView',
      component: ZetosResignView
    },

    {
      path: '/calc',
      name: 'ZetosCalcView',
      component: ZetosCalcView
    },

    {
      path: '/rej',
      //name: 'ZetosRejectView',
      //component: ZetosRejectView
      name: 'RedirectView',
      component: RedirectView
    },


    {
      path: '/aisok',
      name: 'EasyCheckOkView',
      component: EasyCheckOkView
    },


    {
      path: '/pending',
      name: 'ZetosTimeoutPage',
      component: ZetosTimeoutPage
    },

    {
      path: '*',
      redirect: '/'
    }

  ]
});



router.beforeEach((to, from, next) => {

  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/', '/quickform', '/fullform', '/verifycode', '/kontox','/authologic', '/thankyou', '/aisok', '/rej', '/pdf', '/proposal', '/resign', '/pending', '/calc'];

  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');



  // default to client view after login
/*  if (loggedIn && !to.path.match(/(client|\/|fullform|rej|thankyou|proposal|pending)$/)) {


    return next('/client');
  }

  else */


  if (!loggedIn && authRequired ) {


    bus.$emit('login_dialog');

    return next('/');
  }


  next();



});



// WEBPACK FOOTER //
// ./src/router/index.js